import { Matter } from "./Matter";
import { DiscoveryRequestTask } from "./DiscoveryRequestTask";
import { SideType } from "./SideType";

export const discoveryRequestStatus = {
  open: {
    label: "Open",
    color: "blue",
  },
  closed: {
    label: "Closed",
    color: "green",
  },
  in_progress: {
    label: "In Progress",
    color: "yellow",
  },
  missing: {
    label: "Missing",
    color: "red",
  },
};

export type DiscoveryRequestStatus = keyof typeof discoveryRequestStatus;

export interface DiscoveryRequest {
  _id: string;
  title: string;
  description?: string;
  status: DiscoveryRequestStatus;
  side: SideType;
  dueDate: Date;
  matter: Matter["_id"];
  discoveryRequestTasks: DiscoveryRequestTask[]; // Array of tasks associated with this discovery request
  blobName?: string;
  createdAt: Date;
  createdBy: string;
  updatedAt?: Date;
  updatedBy?: string;
}
